<template>
  <div class="wh100">
    <landing-page-banner class="banner" v-if="!isMobile"/>
    <div class="w100" layout="column top-center">

      <div class="map wh100" v-if="!isMobile">
        <img src="/static/images/map.png" srcset="/static/images/map@2x.png"/>
        <map-city-spot v-for="city in cities" class="city-spot" :top="`${city.top}%`" :left="`${city.left}%`" :city="city"/>
      </div>

      <div :class="{'list-map':!isMobile, w100:true}" self="left">
        <div class="city-info black-background" v-for="city in cities" layout="row sm-columns center-justify" @click="click(city)">
          <div self="left">
            <div class="city-name">{{city.name}}</div>
            <div class="city-address">
              <div>{{city.address1}}</div>
            </div>
          </div>
          <div class="city-date" >
            {{city.dateString}}
          </div>
          <div class="city-delimiter"></div>
        </div>
      </div>

    </div>
    <spacing value="2rem"/>
  </div>
</template>

<script>
  import Spacing from "./Spacing";
  import MapCitySpot from "./MapCitySpot";
  import BackendProxy from "@/BackendProxy";
  import Headline from "./Headline";
  import LandingPageBanner from "./LandingPageBanner";
  import checkMobile from 'ismobilejs';

  export default {
    components: {
      LandingPageBanner,
      Headline,
      MapCitySpot,
      Spacing
    },
    name: "smart-map",
    created() {
      // setInterval(() => {
      //   this.cities = null;
      //   this.cities = BackendProxy.instance.cities;
      // }, 1000);
    },
    methods: {
      mouseover() {

      },
      mouseout() {

      },
      click(city) {
        this.$router.push(`/${city.key}`);
      }
    },
    data() {
      return {
        cities: BackendProxy.instance.citiesByDate,
        isMobile: checkMobile.any
      }
    }
  }
</script>

<style lang="scss" scoped>

  $min-width: 700px;

  .map {
    width: 80%;
    max-width: 700px;
    position: relative;
  }

  .map img {
    width: 100%;
    position: relative;
    @media screen and (max-width: $min-width) {
      display: none;
    }
  }

  .city-spot {
    @media screen and (max-width: $min-width) {
      display: none;
    }
  }

  .banner {
    @media screen and (max-width: $min-width) {
      display: none;
    }
  }

  .city-info {
    margin-bottom: 1rem;
    cursor: pointer;

    padding: 0.3rem;
    /*background-color: rgba(0, 159, 227, 0.2);*/
  }

  .city-delimiter {
    margin-top: 0.3rem;
    width:100%;
    border-bottom: rgba(255, 255, 255, 0.2) solid 1px;

  }

  .city-name {
    font-size: 1.4rem;
    font-weight: 400;

    @media screen and (max-width: 375px) {
      font-size: 1.3rem;
    }
    @media screen and (max-width: 320px) {
      font-size: 1.3rem;
    }
  }

  .city-address {
    font-weight: 200;
  }

  .city-date {
    font-weight: 400;
    white-space: nowrap;
    margin-top: 0.1rem;

    @media screen and (max-width: 640px) {
      align-self: flex-start;
    }
  }

  .list-map {
    @media screen and (min-width: $min-width) {
      display: none;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/blocks/SmartMap.vue